import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { PreventOrphansPipe } from '../../pipes/prevent-orphans.pipe';
import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';
import { IconComponent } from '../icon/icon.component';
import { IconContainerComponent } from '../icon-container/icon-container.component';

/**
 * Variant of rt-empty-state that requires explicit numeric image dimensions and uses NgOptimizedImage (ngSrc).
 * Use this instead of rt-empty-state when the image dimensions are known upfront
 * (also if your component need to be exported in Tellent Client).
 */
@Component({
  selector: 'rt-empty-state-2',
  templateUrl: './empty-state-2.component.html',
  styleUrls: ['./empty-state-2.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.min-height.rem]': 'resolveMinHeight(minHeight())',
    '[class.no-content-margin]': '!hasContentMargin()',
    '[class]': 'variant()',
  },
  imports: [NgOptimizedImage, IconComponent, PreventOrphansPipe, IconContainerComponent],
})
export class EmptyState2Component {
  public static readonly DEFAULT_MIN_HEIGHT = 22;
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'small',
      'v-centered',
      'with-padding-top',
      'heading-large-x',
      'heading-margin-top-small',
    ],
  ];

  public readonly variant = input(...ComponentVariantTransform(EmptyState2Component.VARIANTS));
  public readonly minHeight = input<boolean | number>(false);
  public readonly hasContentMargin = input<boolean>(true);
  public readonly imageWidth = input.required<number>();
  public readonly imageHeight = input.required<number>();

  public readonly title = input<string>();
  public readonly desc = input<string>();
  public readonly imageUrl = input<string>();

  public resolveMinHeight(minHeight: boolean | number): null | number {
    return minHeight === true
      ? EmptyState2Component.DEFAULT_MIN_HEIGHT
      : typeof minHeight === 'number'
        ? minHeight
        : null;
  }
}
